import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function saveUtteranceFlagsConfig(requestData, clientKey, userKey) {
  validateUserKey(userKey);
  try {
    requestData.clientKey = clientKey;
    requestData.userKey = userKey;
    const { data } = await apiClient.post("api/saveUtteranceFlagsConfig", requestData);
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
